import { useQuery } from '@apollo/client'
import { Box, Grid } from '@mui/material'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useRegisterPageVisit } from 'recruiter/components/GlobalSearch/hooks/useRegisterPageVisit'
import { GetCompany } from 'recruiter/graphql/companies.gql'
import { recruiterRouteConfig } from 'recruiter/routes'
import useToast from 'shared/components/Toast/useToast'
import useIsMobile from 'shared/hooks/useIsMobile'
import { usePageTitle } from 'shared/hooks/usePageTitle'
import ClientContacts from './ClientContacts'
import CompanyDocuments from './CompanyDocuments'
import FundInformation from './CompanyFundInfo'
import CpiContacts from './CpiContacts'
import EditProfile from './EditProfile'
import EmployeeList from './EmployeeList'
import Notes from './Notes'
import PinnedNotes from './PinnedNotes/PinnedNotesGrid'
import ProfileHeader from './ProfileHeader'

const CompanyOverview = () => {
    const companyId = useParams().companyId ?? ''
    const [edit, setEdit] = useState(false)
    const { data, refetch } = useQuery(GetCompany, {
        variables: { companyId },
    })
    const isMobile = useIsMobile()
    const navigate = useNavigate()
    const toast = useToast()

    usePageTitle(data?.company?.value ?? undefined)

    useRegisterPageVisit({
        type: 'company',
        id: companyId || undefined,
        name: data?.company?.value ?? undefined,
    })

    if (!data) {
        toast({
            title: 'Error',
            severity: 'error',
            message: 'Company not found',
        })

        navigate(recruiterRouteConfig.candidates.path)
        return null
    }

    return (
        <>
            <EditProfile
                key={companyId}
                open={edit}
                onClose={() => setEdit(false)}
                data={data}
                refetch={refetch}
            />
            <ProfileHeader data={data} setEdit={setEdit} />
            <Box sx={{ padding: 2, width: '100%' }}>
                <Grid container spacing={2}>
                    {!isMobile && (
                        <Grid item xs={12}>
                            <PinnedNotes
                                notes={data?.company?.notes}
                                refetch={refetch}
                            />
                        </Grid>
                    )}

                    <Grid item xs={12} md={4}>
                        <CpiContacts data={data} refetch={refetch} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <ClientContacts data={data} refetch={refetch} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FundInformation data={data} refetch={refetch} />
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Notes data={data} refetch={refetch} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CompanyDocuments data={data} refetch={refetch} />
                    </Grid>

                    <Grid item xs={12}>
                        <EmployeeList data={data} refetch={refetch} />
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export default CompanyOverview
